import { FC, ReactNode, useRef, useState } from "react";
import { useClickOutside } from "shared/model";
import { ChevronIcon, formStyles } from "shared/ui";

import styles from "./Popover.module.css";

interface Props {
  // Текст в поле: текущее значение или плейсхолдер.
  summary: string;
  error?: string;
  disabled?: boolean;
  children: (close: () => void) => ReactNode;
}

// Поле формы, по клику раскрывающее панель выбора под собой.
export const Popover: FC<Props> = ({ summary, error, disabled, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const close = () => setIsOpen(false);

  useClickOutside(ref, close, isOpen);

  return (
    <div
      ref={ref}
      className={styles.wrapper}
      onKeyDown={(event) => event.key === "Escape" && close()}
    >
      <button
        type="button"
        className={`${formStyles.input} ${styles.trigger} ${error ? formStyles.inputInvalid : ""}`}
        aria-expanded={isOpen}
        disabled={disabled}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className={styles.summary}>{summary}</span>
        <ChevronIcon direction={isOpen ? "up" : "down"} />
      </button>
      {isOpen && <div className={styles.panel}>{children(close)}</div>}
      {error && <span className={formStyles.error}>{error}</span>}
    </div>
  );
};
